import React from 'react';
import { ProductCard } from './ProductCard';
import IcArrowLeft from '@/assets/icons/ic-arrow-left.svg';
import AiGenerateProduct from '@/assets/icons/ic-ai-generate-01.svg';
import { createIconElement } from '@/lib/utils/createIconElement';
import { useAskStanley } from '@/features/ask-stanley/hooks';
import { LAUNCH_IN_MINUTES_PRODUCTS, MORE_PRODUCTS } from '@/features/dashboard/constants/productDefinitions';

interface ProductSelectionViewProps {
    onBack: () => void;
    onProductSelect: (productType: string) => void;
}

export function ProductSelectionView({ onBack, onProductSelect }: ProductSelectionViewProps) {
    const { openChat, sendMessage, createNewChat } = useAskStanley();

    const handleGetProductIdeas = () => {
        createNewChat();
        openChat('dashboard_card_product_ideas');
        // Send the message after a brief delay to ensure chat is open
        setTimeout(() => {
            sendMessage('Can you give me some product ideas?');
        }, 100);
    };

    return (
        <div className='flex w-full'>
            <div className='flex w-full flex-col gap-4 md:w-96'>
                {/* Header with back button */}
                <div className='flex flex-col gap-2'>
                    <button
                        onClick={onBack}
                        className='flex w-fit cursor-pointer items-center justify-center transition-colors'
                        aria-label='Go back'
                    >
                        <IcArrowLeft className='text-primary-main size-6' />
                    </button>
                    <h2 className='text-sm leading-tight font-bold'>
                        <span className='from-brand-dark to-brand-main bg-gradient-to-r bg-clip-text text-xl text-transparent'>
                            Pick a product or ask me for ideas
                        </span>
                    </h2>
                </div>

                {/* Get product ideas button */}
                <button
                    onClick={handleGetProductIdeas}
                    className='bg-brand-subtle hover:bg-brand-soft flex w-fit cursor-pointer items-center gap-2 rounded-md p-2 text-base font-semibold transition-colors'
                >
                    <div className='from-brand-dark to-brand-main flex size-5 items-center justify-center rounded bg-gradient-to-br'>
                        {createIconElement(AiGenerateProduct, { className: 'size-5 text-canvas' })}
                    </div>
                    Get product ideas
                </button>

                {/* Launch in minutes section */}
                <div>
                    <h3 className='text-primary-main my-2 mb-4'>Launch in minutes</h3>
                    <div className='flex flex-col gap-3'>
                        {LAUNCH_IN_MINUTES_PRODUCTS.map(product => (
                            <ProductCard
                                key={product.id}
                                title={product.title}
                                subtitle={product.subtitle}
                                image={product.image}
                                onClick={() => onProductSelect(product.id)}
                            />
                        ))}
                    </div>
                </div>

                {/* More products section */}
                <div>
                    <h3 className='text-primary-main mb-4'>More products</h3>
                    <div className='flex flex-col gap-3'>
                        {MORE_PRODUCTS.map(product => (
                            <ProductCard
                                key={product.id}
                                title={product.title}
                                subtitle={product.subtitle}
                                image={product.image}
                                onClick={() => onProductSelect(product.id)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
